<template>
  <v-form
    :lazy-validation="true"
    @submit.prevent="handleSubmit"
    v-model="valid"
    ref="form"
  >
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>{{ $t("common.edit") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-card-text>
        <v-text-field
          :label="$t('connector.field.name')"
          name="name"
          prepend-icon="mdi-view-module-outline"
          type="text"
          v-model="payload.name"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col md="10" sm="8">
            <v-autocomplete
              autocomplete="off"
              :label="$t('connector.field.type')"
              name="type"
              prepend-icon="mdi-view-module-outline"
              v-model="payload.type"
              :items="connectorTypes"
              item-text="name"
              item-value="value"
            />
          </v-col>

          <v-col md="2" sm="4">
            <v-switch
              v-model="payload.active"
              :label="$t('connector.field.active')"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col md="8" sm="6" v-if="payload.type == 2">
            <v-text-field
              :label="$t('connector.field.path')"
              name="path"
              prepend-icon="mdi-map-marker-path"
              type="text"
              v-model="payload.path"
            ></v-text-field>
          </v-col>

          <v-col md="4" sm="6" v-if="payload.type == 2">
            <v-text-field
              :label="$t('connector.field.port')"
              name="port"
              type="number"
              prepend-icon="mdi-numeric"
              v-model="payload.port"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <ConnectorOptions
        v-on:update="updateOptions"
        :data="payload.backendOptions"
      />

      <v-card-actions>
        <v-btn color="primary" type="submit" x-large>
          {{ $t("common.update") }}
        </v-btn>
        <v-btn color="error" @click="deleteModal" x-large>
          {{ $t("common.delete") }}
        </v-btn>
      </v-card-actions>

      <v-dialog v-model="dialog" width="450">
        <v-card>
          <v-toolbar dark flat>
            <v-toolbar-title>{{ $t("common.confirmDelete") }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">{{ $t("common.close") }}</v-btn>
            <v-btn color="error" text @click="confirmDelete()">{{
              $t("common.delete")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ConnectorOptions from "@/components/connectors/ConnectorOptions";

export default {
  name: "EditConnector",

  data() {
    return {
      valid: false,
      dialog: false,
      payload: {
        connector: {
          name: "",
          path: "",
          port: undefined,
          type: 0,
          active: true,
        },
        options: [],
      },

      connectorTypes: [
        { name: "Sensor-Online", value: 1 },
        { name: "HTTP", value: 2 },
        { name: "MAFA", value: 3 },
        { name: "MQTT", value: 4 },
      ],
    };
  },

  computed: {
    ...mapState("connectors", ["connector"]),
  },

  methods: {
    ...mapActions("connectors", [
      "editConnector",
      "getConnector",
      "deleteConnector",
    ]),

    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        this.valid = false;
        return;
      }

      let pl = {
        connector: {
          name: this.payload.name,
          path: this.payload.path,
          port: this.payload.port,
          type: this.payload.type,
          active: this.payload.active,
        },
        options: this.payload.backendOptions,
      };

      await this.editConnector({
        connectorId: this.payload.backendConnectorId,
        payload: pl,
      });

      this.$router.go(-1);
    },

    updateOptions(opts) {
      this.payload.options = opts;
    },

    deleteModal() {
      this.dialog = true;
    },

    confirmDelete() {
      this.deleteConnector(this.payload.backendConnectorId);
      this.dialog = false;
      this.$router.push("/connectors");
    },
  },

  async created() {
    let id = this.$route.params.id;
    if (id == undefined) this.$router.push(`/connectors`);

    await this.getConnector(id);
    this.payload = this.connector;
  },

  components: {
    ConnectorOptions,
  },
};
</script>
